import React from "react";
import moment from "moment";
import { getQueryParam } from "utils/url";
import styles from "./demo.module.css";

const parseDate = () => {
  const eventTime = getQueryParam("event_start_time");
  if (eventTime) {
    return moment(new Date(eventTime)).format("hh:mma - dddd D MMMM, YYYY");
  }
  return "";
};

const DemoThanks: React.FC = () => (
  <div className={`container ${styles.demoContainer}`}>
    <h1>
      <span className="fa fa-check-circle" />
      &nbsp;
      <span className="color-primary">Meeting Scheduled.</span> <br />
      We look forward to speaking with you!
    </h1>

    <div className="card" style={{ maxWidth: 930 }}>
      <h2 className={styles.date}>
        <span className="fa fa-calendar" />
        &nbsp;
        {parseDate()}
      </h2>
      <p className={styles.desc}>
        You will receive a confirmation email with the calendar invite and additional details about
        your meeting.
      </p>
    </div>
  </div>
);

export default DemoThanks;
